// @flow

import * as React from "react";
import _ from "lodash";
import ComponentBuilder from "../components/organisms/ComponentBuilder";
import HeroContent from "../components/organisms/HeroContent";

type PropsType = {
    page: any,
};

const Content = (props: PropsType): React.Node => {
    const { page } = props;
    const components =
        _.get(page, "acf.component_builder.component_builder") || [];

    // Hero Content
    const hero = page.acf.hero;

    return (
        <React.Fragment>
            <HeroContent {...hero} heading={page.post_title} />

            <div>
                <div className="page-content page-content--simple">
                    <ComponentBuilder
                        components={components}
                        isContentPageComponent
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

Content.defaultProps = {
    heroTitleSize: "heading-1",
    showRelated: true,
};

export default Content;
